import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Base64String: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  LocalDate: { input: any; output: any; }
};

export type Ablesung = {
  __typename?: 'Ablesung';
  ablesedatum: Scalars['LocalDate']['output'];
  ablesewert: Scalars['Int']['output'];
  aenderer?: Maybe<Scalars['String']['output']>;
  aktiv: Scalars['Boolean']['output'];
  bemerkung?: Maybe<Scalars['String']['output']>;
  ersteller: Scalars['String']['output'];
  erstelltAm: Scalars['DateTime']['output'];
  geaendertAm?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  zaehler: Zaehler;
};

export type AblesungEinreichenInput = {
  ablesedatum: Scalars['LocalDate']['input'];
  ablesewert: Scalars['Int']['input'];
  bemerkung?: InputMaybe<Scalars['String']['input']>;
  dateien?: InputMaybe<Array<InputMaybe<UploadDateiInput>>>;
};

export type CitizenResponse = {
  __typename?: 'CitizenResponse';
  message: Scalars['String']['output'];
  result: ZaehlerBeantragenResultTyp;
};

export type CreateAblesungInput = {
  ablesedatum: Scalars['LocalDate']['input'];
  ablesewert: Scalars['Int']['input'];
  bemerkung?: InputMaybe<Scalars['String']['input']>;
  zaehlerId: Scalars['ID']['input'];
};

export type CreateDateiAblesungInput = {
  ablesungId?: InputMaybe<Scalars['ID']['input']>;
  dateiname: Scalars['String']['input'];
  inhalt: Scalars['String']['input'];
  mimeTyp: Scalars['String']['input'];
  typ: Scalars['String']['input'];
};

export type CreateDateiZaehlerInput = {
  dateiname: Scalars['String']['input'];
  inhalt: Scalars['String']['input'];
  mimeTyp: Scalars['String']['input'];
  typ: Scalars['String']['input'];
  zaehlerAntragId?: InputMaybe<Scalars['ID']['input']>;
  zaehlerId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateKassenzeichenInput = {
  aktiv: Scalars['Boolean']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  kassenzeichen: Scalars['ID']['input'];
};

export type CreateZaehlerAntragInput = {
  beantragungsdatum?: InputMaybe<Scalars['DateTime']['input']>;
  eichdatum: Scalars['LocalDate']['input'];
  einbaudatum: Scalars['LocalDate']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  kassenzeichenId: Scalars['String']['input'];
  naechsteEichung?: InputMaybe<Scalars['LocalDate']['input']>;
  ort: Scalars['String']['input'];
  zaehlernummer: Scalars['String']['input'];
  zaehlerstand: Scalars['Int']['input'];
};

export type CreateZaehlerInput = {
  aktiv: Scalars['Boolean']['input'];
  beantragungsdatum?: InputMaybe<Scalars['DateTime']['input']>;
  eichdatum: Scalars['LocalDate']['input'];
  einbaudatum: Scalars['LocalDate']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  genehmigt: Scalars['Boolean']['input'];
  genehmigtAm?: InputMaybe<Scalars['DateTime']['input']>;
  genehmigtVon?: InputMaybe<Scalars['String']['input']>;
  kassenzeichenId: Scalars['ID']['input'];
  naechsteEichung?: InputMaybe<Scalars['LocalDate']['input']>;
  ort: Scalars['String']['input'];
  zaehlernummer: Scalars['String']['input'];
};

export type DateiAblesung = {
  __typename?: 'DateiAblesung';
  ablesung: Ablesung;
  dateiname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inhalt: Scalars['String']['output'];
  mimeTyp: Scalars['String']['output'];
  typ: Scalars['String']['output'];
};

export type DateiZaehler = {
  __typename?: 'DateiZaehler';
  dateiname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inhalt: Scalars['String']['output'];
  mimeTyp: Scalars['String']['output'];
  typ: Scalars['String']['output'];
  zaehler?: Maybe<Zaehler>;
  zaehlerAntrag?: Maybe<ZaehlerAntrag>;
};

export type Kassenzeichen = {
  __typename?: 'Kassenzeichen';
  aktiv: Scalars['Boolean']['output'];
  email?: Maybe<Scalars['String']['output']>;
  kassenzeichen: Scalars['ID']['output'];
};

export type KassenzeichenFilterInput = {
  aktiv?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  kassenzeichen?: InputMaybe<Scalars['String']['input']>;
};

export type KassenzeichenPage = PageOutput & {
  __typename?: 'KassenzeichenPage';
  content: Array<Maybe<Kassenzeichen>>;
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  _empty?: Maybe<Scalars['String']['output']>;
  ablesungAblehnen: Ablesung;
  ablesungEinreichen: CitizenResponse;
  ablesungGenehmigen: Ablesung;
  aktualisiereEmailAdresse: Kassenzeichen;
  antragAblehnen: ZaehlerAntrag;
  antragBearbeiten: ZaehlerAntrag;
  antragGenehmigen: ZaehlerAntrag;
  createAblesung: Ablesung;
  createDateiAblesung: DateiAblesung;
  createDateiZaehler: DateiZaehler;
  createKassenzeichen: Kassenzeichen;
  createZaehler: Zaehler;
  createZaehlerAntrag: ZaehlerAntrag;
  deleteAblesung: Scalars['Boolean']['output'];
  deleteDateiAblesung: Scalars['Boolean']['output'];
  deleteDateiZaehler: Scalars['Boolean']['output'];
  deleteKassenzeichen?: Maybe<Scalars['Boolean']['output']>;
  deleteZaehler: Scalars['Boolean']['output'];
  deleteZaehlerAntrag: Scalars['Boolean']['output'];
  updateAblesung: Ablesung;
  updateDateiAblesung: DateiAblesung;
  updateDateiZaehler: DateiZaehler;
  updateKassenzeichen: Kassenzeichen;
  updateZaehler: Zaehler;
  updateZaehlerAntrag: ZaehlerAntrag;
  zaehlerBeantragen: CitizenResponse;
};


export type MutationAblesungAblehnenArgs = {
  grund: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationAblesungEinreichenArgs = {
  input: AblesungEinreichenInput;
  zaehlerId: Scalars['ID']['input'];
};


export type MutationAblesungGenehmigenArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAktualisiereEmailAdresseArgs = {
  email: Scalars['String']['input'];
};


export type MutationAntragAblehnenArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAntragBearbeitenArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  genehmigt: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationAntragGenehmigenArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCreateAblesungArgs = {
  input: CreateAblesungInput;
};


export type MutationCreateDateiAblesungArgs = {
  input: CreateDateiAblesungInput;
};


export type MutationCreateDateiZaehlerArgs = {
  input: CreateDateiZaehlerInput;
};


export type MutationCreateKassenzeichenArgs = {
  input: CreateKassenzeichenInput;
};


export type MutationCreateZaehlerArgs = {
  input: CreateZaehlerInput;
};


export type MutationCreateZaehlerAntragArgs = {
  input: CreateZaehlerAntragInput;
};


export type MutationDeleteAblesungArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDateiAblesungArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDateiZaehlerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteKassenzeichenArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteZaehlerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteZaehlerAntragArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUpdateAblesungArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAblesungInput;
};


export type MutationUpdateDateiAblesungArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDateiAblesungInput;
};


export type MutationUpdateDateiZaehlerArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDateiZaehlerInput;
};


export type MutationUpdateKassenzeichenArgs = {
  id: Scalars['ID']['input'];
  input: UpdateKassenzeichenInput;
};


export type MutationUpdateZaehlerArgs = {
  id: Scalars['ID']['input'];
  input: UpdateZaehlerInput;
};


export type MutationUpdateZaehlerAntragArgs = {
  id: Scalars['ID']['input'];
  input: UpdateZaehlerAntragInput;
};


export type MutationZaehlerBeantragenArgs = {
  input: ZaehlerBeantragenInput;
};

export type PageInput = {
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
};

export type PageOutput = {
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  _empty?: Maybe<Scalars['String']['output']>;
  ablesungById?: Maybe<Ablesung>;
  ablesungs: Array<Maybe<Ablesung>>;
  dateiAblesungById?: Maybe<DateiAblesung>;
  dateiAblesungs: Array<Maybe<DateiAblesung>>;
  dateiZaehlerById?: Maybe<DateiZaehler>;
  dateiZaehlers: Array<Maybe<DateiZaehler>>;
  eigeneZaehlerAntraegeAuflisten: Array<Maybe<ZaehlerAntrag>>;
  eigeneZaehlerAuflisten: Array<Maybe<Zaehler>>;
  /** @deprecated Use isValid instead */
  isKassenzeichenValid: Scalars['Boolean']['output'];
  isValid: Scalars['Boolean']['output'];
  kassenzeichenById?: Maybe<Kassenzeichen>;
  kassenzeichens: Array<Maybe<Kassenzeichen>>;
  kassenzeichensPage: KassenzeichenPage;
  myKassenzeichen: Kassenzeichen;
  versionInfo: VersionInfo;
  zaehlerAntragById?: Maybe<ZaehlerAntrag>;
  zaehlerAntrags: Array<Maybe<ZaehlerAntrag>>;
  zaehlerAntragsPage: ZaehlerAntragPage;
  zaehlerById?: Maybe<Zaehler>;
  zaehlerByZaehlernummer: Array<Maybe<Zaehler>>;
  zaehlersPage: ZaehlerPage;
};


export type QueryAblesungByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDateiAblesungByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDateiZaehlerByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryIsKassenzeichenValidArgs = {
  kassenzeichen: Scalars['String']['input'];
};


export type QueryKassenzeichenByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryKassenzeichensArgs = {
  filter?: InputMaybe<KassenzeichenFilterInput>;
  sort?: InputMaybe<Array<InputMaybe<SortInput>>>;
};


export type QueryKassenzeichensPageArgs = {
  filter?: InputMaybe<KassenzeichenFilterInput>;
  page: PageInput;
  sort?: InputMaybe<Array<InputMaybe<SortInput>>>;
};


export type QueryZaehlerAntragByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryZaehlerAntragsArgs = {
  filter?: InputMaybe<ZaehlerAntragFilterInput>;
  sort?: InputMaybe<Array<InputMaybe<SortInput>>>;
};


export type QueryZaehlerAntragsPageArgs = {
  filter?: InputMaybe<ZaehlerAntragFilterInput>;
  page: PageInput;
  sort?: InputMaybe<Array<InputMaybe<SortInput>>>;
};


export type QueryZaehlerByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryZaehlerByZaehlernummerArgs = {
  zaehlernummer: Scalars['String']['input'];
};


export type QueryZaehlersPageArgs = {
  filter?: InputMaybe<ZaehlerFilterInput>;
  page: PageInput;
  sort?: InputMaybe<Array<InputMaybe<SortInput>>>;
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SortInput = {
  direction: SortDirection;
  field: Scalars['String']['input'];
};

export type UpdateAblesungInput = {
  ablesedatum?: InputMaybe<Scalars['LocalDate']['input']>;
  ablesewert?: InputMaybe<Scalars['Int']['input']>;
  aenderer?: InputMaybe<Scalars['String']['input']>;
  aktiv?: InputMaybe<Scalars['Boolean']['input']>;
  bemerkung?: InputMaybe<Scalars['String']['input']>;
  geaendertAm?: InputMaybe<Scalars['DateTime']['input']>;
  zaehlerId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateDateiAblesungInput = {
  dateiname?: InputMaybe<Scalars['String']['input']>;
  inhalt?: InputMaybe<Scalars['String']['input']>;
  mimeTyp?: InputMaybe<Scalars['String']['input']>;
  typ?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDateiZaehlerInput = {
  dateiname?: InputMaybe<Scalars['String']['input']>;
  inhalt?: InputMaybe<Scalars['String']['input']>;
  mimeTyp?: InputMaybe<Scalars['String']['input']>;
  typ?: InputMaybe<Scalars['String']['input']>;
  zaehlerAntragId?: InputMaybe<Scalars['ID']['input']>;
  zaehlerId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateKassenzeichenInput = {
  aktiv?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateZaehlerAntragInput = {
  abgelehnt?: InputMaybe<Scalars['Boolean']['input']>;
  abgelehntAm?: InputMaybe<Scalars['DateTime']['input']>;
  abgelehntVon?: InputMaybe<Scalars['String']['input']>;
  aktiv?: InputMaybe<Scalars['Boolean']['input']>;
  beantragungsdatum?: InputMaybe<Scalars['DateTime']['input']>;
  eichdatum?: InputMaybe<Scalars['LocalDate']['input']>;
  einbaudatum?: InputMaybe<Scalars['LocalDate']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  genehmigt?: InputMaybe<Scalars['Boolean']['input']>;
  genehmigtAm?: InputMaybe<Scalars['DateTime']['input']>;
  genehmigtVon?: InputMaybe<Scalars['String']['input']>;
  naechsteEichung?: InputMaybe<Scalars['LocalDate']['input']>;
  ort?: InputMaybe<Scalars['String']['input']>;
  zaehlernummer?: InputMaybe<Scalars['String']['input']>;
  zaehlerstand?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateZaehlerInput = {
  aktiv?: InputMaybe<Scalars['Boolean']['input']>;
  beantragungsdatum?: InputMaybe<Scalars['DateTime']['input']>;
  eichdatum?: InputMaybe<Scalars['LocalDate']['input']>;
  einbaudatum?: InputMaybe<Scalars['LocalDate']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  genehmigt?: InputMaybe<Scalars['Boolean']['input']>;
  genehmigtAm?: InputMaybe<Scalars['DateTime']['input']>;
  genehmigtVon?: InputMaybe<Scalars['String']['input']>;
  kassenzeichenId?: InputMaybe<Scalars['ID']['input']>;
  naechsteEichung?: InputMaybe<Scalars['LocalDate']['input']>;
  ort?: InputMaybe<Scalars['String']['input']>;
  zaehlernummer?: InputMaybe<Scalars['String']['input']>;
};

export type UploadDateiInput = {
  dateiname: Scalars['String']['input'];
  inhalt: Scalars['String']['input'];
  mimeTyp: Scalars['String']['input'];
  typ: Scalars['String']['input'];
};

export type VersionInfo = {
  __typename?: 'VersionInfo';
  artifact?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type Zaehler = {
  __typename?: 'Zaehler';
  abgelaufeneEichung?: Maybe<Scalars['Boolean']['output']>;
  aktiv: Scalars['Boolean']['output'];
  beantragungsdatum?: Maybe<Scalars['DateTime']['output']>;
  eichdatum: Scalars['LocalDate']['output'];
  einbaudatum: Scalars['LocalDate']['output'];
  email?: Maybe<Scalars['String']['output']>;
  genehmigt: Scalars['Boolean']['output'];
  genehmigtAm?: Maybe<Scalars['DateTime']['output']>;
  genehmigtVon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kassenzeichen: Kassenzeichen;
  letzterZaehlerstand?: Maybe<Scalars['Int']['output']>;
  letzterZaehlerstandDatum?: Maybe<Scalars['LocalDate']['output']>;
  naechsteEichung?: Maybe<Scalars['LocalDate']['output']>;
  ort: Scalars['String']['output'];
  zaehlerAntrag?: Maybe<ZaehlerAntrag>;
  zaehlernummer: Scalars['String']['output'];
};

export type ZaehlerAntrag = {
  __typename?: 'ZaehlerAntrag';
  abgelehnt: Scalars['Boolean']['output'];
  abgelehntAm?: Maybe<Scalars['DateTime']['output']>;
  abgelehntVon?: Maybe<Scalars['String']['output']>;
  aktiv: Scalars['Boolean']['output'];
  beantragungsdatum?: Maybe<Scalars['DateTime']['output']>;
  dateien?: Maybe<Array<Maybe<DateiZaehler>>>;
  eichdatum: Scalars['LocalDate']['output'];
  einbaudatum: Scalars['LocalDate']['output'];
  email?: Maybe<Scalars['String']['output']>;
  genehmigt: Scalars['Boolean']['output'];
  genehmigtAm?: Maybe<Scalars['DateTime']['output']>;
  genehmigtVon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kassenzeichen: Kassenzeichen;
  naechsteEichung?: Maybe<Scalars['LocalDate']['output']>;
  ort: Scalars['String']['output'];
  zaehler?: Maybe<Zaehler>;
  zaehlernummer: Scalars['String']['output'];
};

export type ZaehlerAntragFilterInput = {
  abgelehnt?: InputMaybe<Scalars['Boolean']['input']>;
  aktiv?: InputMaybe<Scalars['Boolean']['input']>;
  beantragungsdatumBis?: InputMaybe<Scalars['DateTime']['input']>;
  beantragungsdatumVon?: InputMaybe<Scalars['DateTime']['input']>;
  eichdatumBis?: InputMaybe<Scalars['LocalDate']['input']>;
  eichdatumVon?: InputMaybe<Scalars['LocalDate']['input']>;
  einbaudatumBis?: InputMaybe<Scalars['LocalDate']['input']>;
  einbaudatumVon?: InputMaybe<Scalars['LocalDate']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  genehmigt?: InputMaybe<Scalars['Boolean']['input']>;
  kassenzeichen?: InputMaybe<KassenzeichenFilterInput>;
  naechsteEichungBis?: InputMaybe<Scalars['LocalDate']['input']>;
  naechsteEichungVon?: InputMaybe<Scalars['LocalDate']['input']>;
  ort?: InputMaybe<Scalars['String']['input']>;
  zaehlernummer?: InputMaybe<Scalars['String']['input']>;
};

export type ZaehlerAntragPage = PageOutput & {
  __typename?: 'ZaehlerAntragPage';
  content: Array<Maybe<ZaehlerAntrag>>;
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type ZaehlerBeantragenInput = {
  dateien?: InputMaybe<Array<InputMaybe<UploadDateiInput>>>;
  eichdatum: Scalars['LocalDate']['input'];
  einbaudatum: Scalars['LocalDate']['input'];
  naechsteEichung: Scalars['LocalDate']['input'];
  ort: Scalars['String']['input'];
  zaehlernummer: Scalars['String']['input'];
  zaehlerstand: Scalars['Int']['input'];
};

export enum ZaehlerBeantragenResultTyp {
  Eingegangen = 'EINGEGANGEN',
  Fehler = 'FEHLER',
  Sonstiges = 'SONSTIGES'
}

export type ZaehlerFilterInput = {
  aktiv?: InputMaybe<Scalars['Boolean']['input']>;
  beantragungsdatum?: InputMaybe<Scalars['DateTime']['input']>;
  eichdatum?: InputMaybe<Scalars['LocalDate']['input']>;
  einbaudatum?: InputMaybe<Scalars['LocalDate']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  genehmigt?: InputMaybe<Scalars['Boolean']['input']>;
  genehmigtAm?: InputMaybe<Scalars['DateTime']['input']>;
  genehmigtVon?: InputMaybe<Scalars['String']['input']>;
  kassenzeichen?: InputMaybe<KassenzeichenFilterInput>;
  naechsteEichung?: InputMaybe<Scalars['LocalDate']['input']>;
  ort?: InputMaybe<Scalars['String']['input']>;
  zaehlerAntrag?: InputMaybe<ZaehlerAntragFilterInput>;
  zaehlernummer?: InputMaybe<Scalars['String']['input']>;
};

export type ZaehlerPage = PageOutput & {
  __typename?: 'ZaehlerPage';
  content: Array<Maybe<Zaehler>>;
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type EigeneZaehlerAntraegeAuflistenQueryVariables = Exact<{ [key: string]: never; }>;


export type EigeneZaehlerAntraegeAuflistenQuery = { __typename?: 'Query', eigeneZaehlerAntraegeAuflisten: Array<{ __typename?: 'ZaehlerAntrag', id: string, zaehlernummer: string, eichdatum: any, naechsteEichung?: any | null, ort: string, einbaudatum: any, genehmigt: boolean, abgelehnt: boolean } | null> };

export type EigeneZaehlerAuflistenQueryVariables = Exact<{ [key: string]: never; }>;


export type EigeneZaehlerAuflistenQuery = { __typename?: 'Query', eigeneZaehlerAuflisten: Array<{ __typename?: 'Zaehler', id: string, zaehlernummer: string, eichdatum: any, naechsteEichung?: any | null, ort: string, einbaudatum: any, genehmigt: boolean, letzterZaehlerstand?: number | null, letzterZaehlerstandDatum?: any | null } | null> };

export type IsValidQueryVariables = Exact<{ [key: string]: never; }>;


export type IsValidQuery = { __typename?: 'Query', isValid: boolean };

export type MyKassenzeichenQueryVariables = Exact<{ [key: string]: never; }>;


export type MyKassenzeichenQuery = { __typename?: 'Query', myKassenzeichen: { __typename?: 'Kassenzeichen', kassenzeichen: string, email?: string | null } };

export type AktualisiereEmailAdresseMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type AktualisiereEmailAdresseMutation = { __typename?: 'Mutation', aktualisiereEmailAdresse: { __typename?: 'Kassenzeichen', email?: string | null } };

export type AblesungEinreichenMutationVariables = Exact<{
  zaehlerId: Scalars['ID']['input'];
  input: AblesungEinreichenInput;
}>;


export type AblesungEinreichenMutation = { __typename?: 'Mutation', ablesungEinreichen: { __typename?: 'CitizenResponse', result: ZaehlerBeantragenResultTyp, message: string } };

export type ZaehlerBeantragenMutationVariables = Exact<{
  input: ZaehlerBeantragenInput;
}>;


export type ZaehlerBeantragenMutation = { __typename?: 'Mutation', zaehlerBeantragen: { __typename?: 'CitizenResponse', result: ZaehlerBeantragenResultTyp, message: string } };

export const EigeneZaehlerAntraegeAuflistenDocument = gql`
    query eigeneZaehlerAntraegeAuflisten {
  eigeneZaehlerAntraegeAuflisten {
    id
    zaehlernummer
    eichdatum
    naechsteEichung
    ort
    einbaudatum
    genehmigt
    abgelehnt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EigeneZaehlerAntraegeAuflistenGQL extends Apollo.Query<EigeneZaehlerAntraegeAuflistenQuery, EigeneZaehlerAntraegeAuflistenQueryVariables> {
    document = EigeneZaehlerAntraegeAuflistenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EigeneZaehlerAuflistenDocument = gql`
    query eigeneZaehlerAuflisten {
  eigeneZaehlerAuflisten {
    id
    zaehlernummer
    eichdatum
    naechsteEichung
    ort
    einbaudatum
    genehmigt
    letzterZaehlerstand
    letzterZaehlerstandDatum
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EigeneZaehlerAuflistenGQL extends Apollo.Query<EigeneZaehlerAuflistenQuery, EigeneZaehlerAuflistenQueryVariables> {
    document = EigeneZaehlerAuflistenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const IsValidDocument = gql`
    query isValid {
  isValid
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class IsValidGQL extends Apollo.Query<IsValidQuery, IsValidQueryVariables> {
    document = IsValidDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MyKassenzeichenDocument = gql`
    query MyKassenzeichen {
  myKassenzeichen {
    kassenzeichen
    email
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MyKassenzeichenGQL extends Apollo.Query<MyKassenzeichenQuery, MyKassenzeichenQueryVariables> {
    document = MyKassenzeichenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AktualisiereEmailAdresseDocument = gql`
    mutation AktualisiereEmailAdresse($email: String!) {
  aktualisiereEmailAdresse(email: $email) {
    email
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AktualisiereEmailAdresseGQL extends Apollo.Mutation<AktualisiereEmailAdresseMutation, AktualisiereEmailAdresseMutationVariables> {
    document = AktualisiereEmailAdresseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AblesungEinreichenDocument = gql`
    mutation ablesungEinreichen($zaehlerId: ID!, $input: AblesungEinreichenInput!) {
  ablesungEinreichen(zaehlerId: $zaehlerId, input: $input) {
    result
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AblesungEinreichenGQL extends Apollo.Mutation<AblesungEinreichenMutation, AblesungEinreichenMutationVariables> {
    document = AblesungEinreichenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ZaehlerBeantragenDocument = gql`
    mutation zaehlerBeantragen($input: ZaehlerBeantragenInput!) {
  zaehlerBeantragen(input: $input) {
    result
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ZaehlerBeantragenGQL extends Apollo.Mutation<ZaehlerBeantragenMutation, ZaehlerBeantragenMutationVariables> {
    document = ZaehlerBeantragenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }